module.exports = __webpack_public_path__ + "img/Group138.6ab09e39.png";